export const SHARED_PARTY_IDENTITY_KEYS = [
  'hasEntityTitle',
  'entityTitle',
  'entityAddress',
  'entityTaxID',
  'entityState',
  'borrowerType',
  'borrowerPosition',
  'ownershipPercentage',
  'titleVesting',
  'isLayeredEntity',
  'layerCount',
  'additionalLayer',
  'linkedEntity',
  'settlers',
  'settlorCount',
  'trustDate',
  'firstName',
  'middleName',
  'lastName',
  'email',
  'phone',
  'cellPhone',
  'homePhone',
  'workPhone',
  'ssn',
  'dob',
  'presentAddress',
  'mailingAddress',
] as const

export const SHARED_ADDITIONAL_MEMBER_IDENTITY_KEYS = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'dob',
  'ssn',
  'presentAddress',
] as const

export type AssociatedPartyMatch = {
  loanNumber: number
  borrowerSeperator: string
  entityTitle?: string
  name?: string
  email?: string
}

export type AssociatedAdditionalMemberMatch = {
  loanNumber: number
  memberId: number
  borrowerSeperator?: string
  name?: string
  email?: string
}

export function hasSharedPartyIdentityChanges(data: Record<string, any>): boolean {
  return SHARED_PARTY_IDENTITY_KEYS.some((key) => data[key] !== undefined)
}

export function hasSharedAdditionalMemberIdentityChanges(
  prev: Record<string, any>,
  next: Record<string, any>,
): boolean {
  return SHARED_ADDITIONAL_MEMBER_IDENTITY_KEYS.some((key) => prev[key] !== next[key] && next[key] !== undefined)
}

export function formatAssociatedPartyLabel(match: AssociatedPartyMatch): string {
  const party = match.name || match.entityTitle || match.email || match.borrowerSeperator
  return `Loan ${match.loanNumber}${party ? ` — ${party}` : ''}`
}

export function formatAssociatedMemberLabel(match: AssociatedAdditionalMemberMatch): string {
  const party = match.name || match.email || `#${match.memberId}`
  return `Loan ${match.loanNumber} — ${party}`
}
